exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-table__body-wrapper[data-v-6e84eb6e]{max-height:100%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e84eb6e","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/dstConfig/dstConfig.vue
// module id = Gn2f
// module chunks = 17